// react
import { Suspense } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import {
  createFileRoute,
  useNavigate,
  useParams,
} from '@tanstack/react-router';

// api
import { useGetAccountByIdQuery } from '@/api/recalc/endpoints/accountsApiSlice';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';

// feature-components
import CreateAlarmGroupForm from '@/features/alarm-hub/components/alarm-group/forms/CreateAlarmGroupForm.tsx';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/alarms/advanced/create',
)({
  component: RouteComponent,
  staticData: { crumb: 'alarms:alarmGroups.createGroup' },
});

function RouteComponent() {
  const { t } = useTranslation('alarms');
  const navigate = useNavigate();
  const { accountId } = useParams({ strict: false });
  const { data: account } = useGetAccountByIdQuery(accountId);

  const handleCancel = () => {
    navigate({ to: '..' });
  };

  return (
    <Suspense>
      <PageContainer>
        <PageHeader title={t('dialog.create_new_alarm_group')} />

        <CreateAlarmGroupForm
          selectedAccountId={account?.AccountId}
          userOptions={account?.UserRoles || []}
          onSuccess={() => navigate({ to: '..' })}
          onCancel={handleCancel}
        />
      </PageContainer>
    </Suspense>
  );
}
